// Mock data for Zeevogo landing page

export const jobListings = [
  {
    id: 1,
    country: "Poland",
    city: "Various Cities",
    role: "Delivery Agent",
    positions: 500,
    salary: 2500,
    currency: "EUR",
    requirements: ["Basic English", "12th Pass", "No Criminal Records"],
    status: "Hiring Now",
    benefits: ["Health Insurance", "Accommodation Support", "Visa Assistance"]
  },
  {
    id: 2,
    country: "Romania",
    city: "Bucharest",
    role: "Delivery Agent",
    positions: 300,
    salary: 1400,
    currency: "EUR",
    requirements: ["Basic English", "12th Pass", "No Criminal Records"],
    status: "Hiring Now",
    benefits: ["Health Insurance", "Transport Allowance", "Visa Assistance"]
  },
  {
    id: 3,
    country: "Romania",
    city: "Cluj-Napoca",
    role: "Factory Worker",
    positions: 50,
    salary: 1200,
    currency: "EUR",
    requirements: ["Basic English", "12th Pass", "No Criminal Records"],
    status: "Hiring Now",
    benefits: ["Health Insurance", "Overtime Pay", "Visa Assistance"]
  },
  {
    id: 4,
    country: "Croatia",
    city: "Zagreb",
    role: "Delivery Agent",
    positions: 280,
    salary: 1900,
    currency: "EUR",
    requirements: ["Basic English", "12th Pass", "No Criminal Records"],
    status: "Hiring Now",
    benefits: ["Health Insurance", "Performance Bonus", "Visa Assistance"]
  },
  {
    id: 5,
    country: "India",
    city: "Hyderabad",
    role: "Taxi Driver",
    positions: 100,
    salary: 40000,
    salaryRange: "30000-50000",
    currency: "INR",
    requirements: ["Valid Driving License", "12th Pass", "No Criminal Records"],
    status: "Hiring Now",
    benefits: ["Flexible Hours", "Performance Bonus", "Fuel Allowance"]
  },
  {
    id: 6,
    country: "India",
    city: "Bangalore",
    role: "Taxi Driver",
    positions: 120,
    salary: 40000,
    salaryRange: "30000-50000",
    currency: "INR",
    requirements: ["Valid Driving License", "12th Pass", "No Criminal Records"],
    status: "Hiring Now",
    benefits: ["Flexible Hours", "Performance Bonus", "Fuel Allowance"]
  },
  {
    id: 7,
    country: "India",
    city: "Delhi",
    role: "Taxi Driver",
    positions: 100,
    salary: 40000,
    salaryRange: "30000-50000",
    currency: "INR",
    requirements: ["Valid Driving License", "12th Pass", "No Criminal Records"],
    status: "Hiring Now",
    benefits: ["Flexible Hours", "Performance Bonus", "Fuel Allowance"]
  },
  {
    id: 8,
    country: "India",
    city: "Pune",
    role: "Taxi Driver",
    positions: 90,
    salary: 40000,
    salaryRange: "30000-50000",
    currency: "INR",
    requirements: ["Valid Driving License", "12th Pass", "No Criminal Records"],
    status: "Hiring Now",
    benefits: ["Flexible Hours", "Performance Bonus", "Fuel Allowance"]
  },
  {
    id: 9,
    country: "India",
    city: "Mumbai",
    role: "Taxi Driver",
    positions: 90,
    salary: 40000,
    salaryRange: "30000-50000",
    currency: "INR",
    requirements: ["Valid Driving License", "12th Pass", "No Criminal Records"],
    status: "Hiring Now",
    benefits: ["Flexible Hours", "Performance Bonus", "Fuel Allowance"]
  }
];

export const countries = [
  {
    name: "India",
    totalPositions: 500,
    avgSalary: 40000,
    currency: "INR",
    available: true,
    flag: "🇮🇳",
    description: "Taxi driver opportunities across major metropolitan cities"
  },
  {
    name: "Poland",
    totalPositions: 500,
    avgSalary: 2500,
    currency: "EUR",
    available: true,
    flag: "🇵🇱",
    description: "High demand for delivery agents with excellent compensation"
  },
  {
    name: "Romania",
    totalPositions: 350,
    avgSalary: 1300,
    currency: "EUR",
    available: true,
    flag: "🇷🇴",
    description: "Multiple opportunities in delivery and manufacturing sectors"
  },
  {
    name: "Croatia",
    totalPositions: 280,
    avgSalary: 1900,
    currency: "EUR",
    available: true,
    flag: "🇭🇷",
    description: "Growing market with competitive salaries"
  },
  {
    name: "Germany",
    totalPositions: 0,
    avgSalary: 0,
    currency: "EUR",
    available: false,
    flag: "🇩🇪",
    description: "Coming in Q3 2026"
  },
  {
    name: "Spain",
    totalPositions: 0,
    avgSalary: 0,
    currency: "EUR",
    available: false,
    flag: "🇪🇸",
    description: "Coming in Q4 2026"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Rajesh Kumar",
    role: "Delivery Agent in Poland",
    image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop",
    content: "Zeevogo changed my life! I'm now earning €2500/month in Poland. The visa process was smooth and they helped me with accommodation.",
    rating: 5,
    location: "Warsaw, Poland"
  },
  {
    id: 2,
    name: "Priya Sharma",
    role: "Agency Partner",
    image: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=150&h=150&fit=crop",
    content: "As an agency partner, Zeevogo provides excellent support and commission structure. We've successfully placed 50+ candidates.",
    rating: 5,
    location: "Mumbai, India"
  },
  {
    id: 3,
    name: "Vikram Singh",
    role: "Taxi Driver in Delhi",
    image: "https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=150&h=150&fit=crop",
    content: "Great earning opportunity with flexible hours! Making ₹45,000/month as a taxi driver. Zeevogo helped me get started quickly.",
    rating: 5,
    location: "Delhi, India"
  },
  {
    id: 4,
    name: "Amit Patel",
    role: "Delivery Agent in Croatia",
    image: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=150&h=150&fit=crop",
    content: "Great opportunity! Working in Zagreb with good salary and benefits. Zeevogo team was very professional throughout.",
    rating: 5,
    location: "Zagreb, Croatia"
  }
];

export const howItWorksSteps = [
  {
    step: 1,
    title: "Apply Online",
    description: "Fill out our simple application form with your basic details and preferences"
  },
  {
    step: 2,
    title: "Document Verification",
    description: "Submit required documents for verification and background check"
  },
  {
    step: 3,
    title: "Interview & Selection",
    description: "Attend interview with our partner companies and get selected"
  },
  {
    step: 4,
    title: "Processing & Training",
    description: "Complete paperwork, visa processing (if required), and onboarding training"
  },
  {
    step: 5,
    title: "Start Your Journey",
    description: "Begin your new career with full support from our team"
  }
];

export const partnershipBenefits = {
  agency: [
    "Attractive commission structure up to 15%",
    "Dedicated account manager support",
    "Marketing materials and collateral",
    "Fast-track visa processing for candidates",
    "Regular training and updates",
    "CRM access for candidate tracking"
  ],
  agent: [
    "Earn commission on every successful placement",
    "Flexible working hours",
    "No investment required",
    "Training and certification provided",
    "Digital marketing support",
    "Performance-based incentives"
  ]
};

export const contactInfo = {
  phone: "+91 7842974271",
  email: "info@zeevogo.com"
};
